declare namespace $ {

	export class $shm_hitalama_map_widget_float_settings_posts extends $shm_hitalama_map_widget_float_settings {
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=posts.view.tree.d.ts.map